import React, { FC } from 'react'
import styled from 'styled-components'
import { Option } from '../../../../../lib/options'

type Props = {
  option: Option
  inputValueMatchesDialogIdButNotDialogName: boolean
}

export const FormattedLabel: FC<Props> = React.memo(function FormattedLabel({
  option,
  inputValueMatchesDialogIdButNotDialogName
}) {
  if (!option) {
    return null
  }

  if (inputValueMatchesDialogIdButNotDialogName) {
    return (
      <>
        {option.label}

        {inputValueMatchesDialogIdButNotDialogName && (
          <AdditionalText> (found by id)</AdditionalText>
        )}
      </>
    )
  }

  return <>{option.label}</>
})

export type FormattedLabelProps = Props

const AdditionalText = styled.span`
  color: ${props => props.theme.colors.grey};
`
